function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var $50d5d6a623389320$exports = require("./utils.main.js");
var $e1e8ada727fae1a1$exports = require("./placeholders.main.js");
var $iqS8N$internationalizeddate = require("@internationalized/date");
var $iqS8N$reactstatelyform = require("@react-stately/form");
var $iqS8N$reactstatelyutils = require("@react-stately/utils");
var $iqS8N$react = require("react");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useDateFieldState", function () {
  return $596a1f0f523d6752$export$60e84778edff6d26;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $596a1f0f523d6752$var$EDITABLE_SEGMENTS = {
  year: true,
  month: true,
  day: true,
  hour: true,
  minute: true,
  second: true,
  dayPeriod: true,
  era: true
};
var $596a1f0f523d6752$var$PAGE_STEP = {
  year: 5,
  month: 2,
  day: 7,
  hour: 2,
  minute: 15,
  second: 15
};
// Node seems to convert everything to lowercase...
var $596a1f0f523d6752$var$TYPE_MAPPING = {
  dayperiod: 'dayPeriod'
};
function $596a1f0f523d6752$export$60e84778edff6d26(props) {
  var locale = props.locale,
    createCalendar = props.createCalendar,
    hideTimeZone = props.hideTimeZone,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$isReadOnly = props.isReadOnly,
    isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly,
    _props$isRequired = props.isRequired,
    isRequired = _props$isRequired === void 0 ? false : _props$isRequired,
    minValue = props.minValue,
    maxValue = props.maxValue,
    isDateUnavailable = props.isDateUnavailable;
  var v = props.value || props.defaultValue || props.placeholderValue || null;
  var _ref = (0, $50d5d6a623389320$exports.useDefaultProps)(v, props.granularity),
    _ref2 = _slicedToArray(_ref, 2),
    granularity = _ref2[0],
    defaultTimeZone = _ref2[1];
  var timeZone = defaultTimeZone || 'UTC';
  // props.granularity must actually exist in the value if one is provided.
  if (v && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
  var defaultFormatter = (0, $iqS8N$react.useMemo)(function () {
    return new (0, $iqS8N$internationalizeddate.DateFormatter)(locale);
  }, [locale]);
  var calendar = (0, $iqS8N$react.useMemo)(function () {
    return createCalendar(defaultFormatter.resolvedOptions().calendar);
  }, [createCalendar, defaultFormatter]);
  var _props_defaultValue;
  var _ref3 = (0, $iqS8N$reactstatelyutils.useControlledState)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange),
    _ref4 = _slicedToArray(_ref3, 2),
    value = _ref4[0],
    setDate = _ref4[1];
  var calendarValue = (0, $iqS8N$react.useMemo)(function () {
    var _convertValue;
    return (_convertValue = (0, $50d5d6a623389320$exports.convertValue)(value, calendar)) !== null && _convertValue !== void 0 ? _convertValue : null;
  }, [value, calendar]);
  // We keep track of the placeholder date separately in state so that onChange is not called
  // until all segments are set. If the value === null (not undefined), then assume the component
  // is controlled, so use the placeholder as the value until all segments are entered so it doesn't
  // change from uncontrolled to controlled and emit a warning.
  var _ref5 = (0, $iqS8N$react.useState)(function () {
      return (0, $50d5d6a623389320$exports.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone);
    }),
    _ref6 = _slicedToArray(_ref5, 2),
    placeholderDate = _ref6[0],
    setPlaceholderDate = _ref6[1];
  var val = calendarValue || placeholderDate;
  var showEra = calendar.identifier === 'gregory' && val.era === 'BC';
  var formatOpts = (0, $iqS8N$react.useMemo)(function () {
    var _props_maxGranularity;
    return {
      granularity: granularity,
      maxGranularity: (_props_maxGranularity = props.maxGranularity) !== null && _props_maxGranularity !== void 0 ? _props_maxGranularity : 'year',
      timeZone: defaultTimeZone,
      hideTimeZone: hideTimeZone,
      hourCycle: props.hourCycle,
      showEra: showEra,
      shouldForceLeadingZeros: props.shouldForceLeadingZeros
    };
  }, [props.maxGranularity, granularity, props.hourCycle, props.shouldForceLeadingZeros, defaultTimeZone, hideTimeZone, showEra]);
  var opts = (0, $iqS8N$react.useMemo)(function () {
    return (0, $50d5d6a623389320$exports.getFormatOptions)({}, formatOpts);
  }, [formatOpts]);
  var dateFormatter = (0, $iqS8N$react.useMemo)(function () {
    return new (0, $iqS8N$internationalizeddate.DateFormatter)(locale, opts);
  }, [locale, opts]);
  var resolvedOptions = (0, $iqS8N$react.useMemo)(function () {
    return dateFormatter.resolvedOptions();
  }, [dateFormatter]);
  // Determine how many editable segments there are for validation purposes.
  // The result is cached for performance.
  var allSegments = (0, $iqS8N$react.useMemo)(function () {
    return dateFormatter.formatToParts(new Date()).filter(function (seg) {
      return $596a1f0f523d6752$var$EDITABLE_SEGMENTS[seg.type];
    }).reduce(function (p, seg) {
      return p[seg.type] = true, p;
    }, {});
  }, [dateFormatter]);
  var _ref7 = (0, $iqS8N$react.useState)(function () {
      return props.value || props.defaultValue ? _objectSpread({}, allSegments) : {};
    }),
    _ref8 = _slicedToArray(_ref7, 2),
    validSegments = _ref8[0],
    setValidSegments = _ref8[1];
  var clearedSegment = (0, $iqS8N$react.useRef)(null);
  // Reset placeholder when calendar changes
  var lastCalendarIdentifier = (0, $iqS8N$react.useRef)(calendar.identifier);
  (0, $iqS8N$react.useEffect)(function () {
    if (calendar.identifier !== lastCalendarIdentifier.current) {
      lastCalendarIdentifier.current = calendar.identifier;
      setPlaceholderDate(function (placeholder) {
        return Object.keys(validSegments).length > 0 ? (0, $iqS8N$internationalizeddate.toCalendar)(placeholder, calendar) : (0, $50d5d6a623389320$exports.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone);
      });
    }
  }, [calendar, granularity, validSegments, defaultTimeZone, props.placeholderValue]);
  // If there is a value prop, and some segments were previously placeholders, mark them all as valid.
  if (value && Object.keys(validSegments).length < Object.keys(allSegments).length) {
    validSegments = _objectSpread({}, allSegments);
    setValidSegments(validSegments);
  }
  // If the value is set to null and all segments are valid, reset the placeholder.
  if (value == null && Object.keys(validSegments).length === Object.keys(allSegments).length) {
    validSegments = {};
    setValidSegments(validSegments);
    setPlaceholderDate((0, $50d5d6a623389320$exports.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone));
  }
  // If all segments are valid, use the date from state, otherwise use the placeholder date.
  var displayValue = calendarValue && Object.keys(validSegments).length >= Object.keys(allSegments).length ? calendarValue : placeholderDate;
  var setValue = function setValue(newValue) {
    if (props.isDisabled || props.isReadOnly) return;
    var validKeys = Object.keys(validSegments);
    var allKeys = Object.keys(allSegments);
    // if all the segments are completed or a timefield with everything but am/pm set the time, also ignore when am/pm cleared
    if (newValue == null) {
      setDate(null);
      setPlaceholderDate((0, $50d5d6a623389320$exports.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone));
      setValidSegments({});
    } else if (validKeys.length >= allKeys.length || validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod && clearedSegment.current !== 'dayPeriod') {
      // The display calendar should not have any effect on the emitted value.
      // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
      newValue = (0, $iqS8N$internationalizeddate.toCalendar)(newValue, (v === null || v === void 0 ? void 0 : v.calendar) || new (0, $iqS8N$internationalizeddate.GregorianCalendar)());
      setDate(newValue);
    } else setPlaceholderDate(newValue);
    clearedSegment.current = null;
  };
  var dateValue = (0, $iqS8N$react.useMemo)(function () {
    return displayValue.toDate(timeZone);
  }, [displayValue, timeZone]);
  var segments = (0, $iqS8N$react.useMemo)(function () {
    return dateFormatter.formatToParts(dateValue).map(function (segment) {
      var isEditable = $596a1f0f523d6752$var$EDITABLE_SEGMENTS[segment.type];
      if (segment.type === 'era' && calendar.getEras().length === 1) isEditable = false;
      var isPlaceholder = $596a1f0f523d6752$var$EDITABLE_SEGMENTS[segment.type] && !validSegments[segment.type];
      var placeholder = $596a1f0f523d6752$var$EDITABLE_SEGMENTS[segment.type] ? (0, $e1e8ada727fae1a1$exports.getPlaceholder)(segment.type, segment.value, locale) : null;
      return _objectSpread(_objectSpread({
        type: $596a1f0f523d6752$var$TYPE_MAPPING[segment.type] || segment.type,
        text: isPlaceholder ? placeholder : segment.value
      }, $596a1f0f523d6752$var$getSegmentLimits(displayValue, segment.type, resolvedOptions)), {}, {
        isPlaceholder: isPlaceholder,
        placeholder: placeholder,
        isEditable: isEditable
      });
    });
  }, [dateValue, validSegments, dateFormatter, resolvedOptions, displayValue, calendar, locale]);
  // When the era field appears, mark it valid if the year field is already valid.
  // If the era field disappears, remove it from the valid segments.
  if (allSegments.era && validSegments.year && !validSegments.era) {
    validSegments.era = true;
    setValidSegments(_objectSpread({}, validSegments));
  } else if (!allSegments.era && validSegments.era) {
    delete validSegments.era;
    setValidSegments(_objectSpread({}, validSegments));
  }
  var markValid = function markValid(part) {
    validSegments[part] = true;
    if (part === 'year' && allSegments.era) validSegments.era = true;
    setValidSegments(_objectSpread({}, validSegments));
  };
  var adjustSegment = function adjustSegment(type, amount) {
    if (!validSegments[type]) {
      markValid(type);
      var validKeys = Object.keys(validSegments);
      var allKeys = Object.keys(allSegments);
      if (validKeys.length >= allKeys.length || validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) setValue(displayValue);
    } else setValue($596a1f0f523d6752$var$addSegment(displayValue, type, amount, resolvedOptions));
  };
  var builtinValidation = (0, $iqS8N$react.useMemo)(function () {
    return (0, $50d5d6a623389320$exports.getValidationResult)(value, minValue, maxValue, isDateUnavailable, formatOpts);
  }, [value, minValue, maxValue, isDateUnavailable, formatOpts]);
  var validation = (0, $iqS8N$reactstatelyform.useFormValidationState)(_objectSpread(_objectSpread({}, props), {}, {
    value: value,
    builtinValidation: builtinValidation
  }));
  var isValueInvalid = validation.displayValidation.isInvalid;
  var validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
  var _props_maxGranularity;
  return _objectSpread(_objectSpread({}, validation), {}, {
    value: calendarValue,
    dateValue: dateValue,
    calendar: calendar,
    setValue: setValue,
    segments: segments,
    dateFormatter: dateFormatter,
    validationState: validationState,
    isInvalid: isValueInvalid,
    granularity: granularity,
    maxGranularity: (_props_maxGranularity = props.maxGranularity) !== null && _props_maxGranularity !== void 0 ? _props_maxGranularity : 'year',
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired,
    increment: function increment(part) {
      adjustSegment(part, 1);
    },
    decrement: function decrement(part) {
      adjustSegment(part, -1);
    },
    incrementPage: function incrementPage(part) {
      adjustSegment(part, $596a1f0f523d6752$var$PAGE_STEP[part] || 1);
    },
    decrementPage: function decrementPage(part) {
      adjustSegment(part, -($596a1f0f523d6752$var$PAGE_STEP[part] || 1));
    },
    setSegment: function setSegment(part, v) {
      markValid(part);
      setValue($596a1f0f523d6752$var$setSegment(displayValue, part, v, resolvedOptions));
    },
    confirmPlaceholder: function confirmPlaceholder() {
      if (props.isDisabled || props.isReadOnly) return;
      // Confirm the placeholder if only the day period is not filled in.
      var validKeys = Object.keys(validSegments);
      var allKeys = Object.keys(allSegments);
      if (validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) {
        validSegments = _objectSpread({}, allSegments);
        setValidSegments(validSegments);
        setValue(displayValue.copy());
      }
    },
    clearSegment: function clearSegment(part) {
      delete validSegments[part];
      clearedSegment.current = part;
      setValidSegments(_objectSpread({}, validSegments));
      var placeholder = (0, $50d5d6a623389320$exports.createPlaceholderDate)(props.placeholderValue, granularity, calendar, defaultTimeZone);
      var value = displayValue;
      // Reset day period to default without changing the hour.
      if (part === 'dayPeriod' && 'hour' in displayValue && 'hour' in placeholder) {
        var isPM = displayValue.hour >= 12;
        var shouldBePM = placeholder.hour >= 12;
        if (isPM && !shouldBePM) value = displayValue.set({
          hour: displayValue.hour - 12
        });else if (!isPM && shouldBePM) value = displayValue.set({
          hour: displayValue.hour + 12
        });
      } else if (part in displayValue) value = displayValue.set(_defineProperty({}, part, placeholder[part]));
      setDate(null);
      setValue(value);
    },
    formatValue: function formatValue(fieldOptions) {
      if (!calendarValue) return '';
      var formatOptions = (0, $50d5d6a623389320$exports.getFormatOptions)(fieldOptions, formatOpts);
      var formatter = new (0, $iqS8N$internationalizeddate.DateFormatter)(locale, formatOptions);
      return formatter.format(dateValue);
    },
    getDateFormatter: function getDateFormatter(locale, formatOptions) {
      var newOptions = _objectSpread(_objectSpread({}, formatOpts), formatOptions);
      var newFormatOptions = (0, $50d5d6a623389320$exports.getFormatOptions)({}, newOptions);
      return new (0, $iqS8N$internationalizeddate.DateFormatter)(locale, newFormatOptions);
    }
  });
}
function $596a1f0f523d6752$var$getSegmentLimits(date, type, options) {
  switch (type) {
    case 'era':
      {
        var eras = date.calendar.getEras();
        return {
          value: eras.indexOf(date.era),
          minValue: 0,
          maxValue: eras.length - 1
        };
      }
    case 'year':
      return {
        value: date.year,
        minValue: 1,
        maxValue: date.calendar.getYearsInEra(date)
      };
    case 'month':
      return {
        value: date.month,
        minValue: (0, $iqS8N$internationalizeddate.getMinimumMonthInYear)(date),
        maxValue: date.calendar.getMonthsInYear(date)
      };
    case 'day':
      return {
        value: date.day,
        minValue: (0, $iqS8N$internationalizeddate.getMinimumDayInMonth)(date),
        maxValue: date.calendar.getDaysInMonth(date)
      };
  }
  if ('hour' in date) switch (type) {
    case 'dayPeriod':
      return {
        value: date.hour >= 12 ? 12 : 0,
        minValue: 0,
        maxValue: 12
      };
    case 'hour':
      if (options.hour12) {
        var isPM = date.hour >= 12;
        return {
          value: date.hour,
          minValue: isPM ? 12 : 0,
          maxValue: isPM ? 23 : 11
        };
      }
      return {
        value: date.hour,
        minValue: 0,
        maxValue: 23
      };
    case 'minute':
      return {
        value: date.minute,
        minValue: 0,
        maxValue: 59
      };
    case 'second':
      return {
        value: date.second,
        minValue: 0,
        maxValue: 59
      };
  }
  return {};
}
function $596a1f0f523d6752$var$addSegment(value, part, amount, options) {
  switch (part) {
    case 'era':
    case 'year':
    case 'month':
    case 'day':
      return value.cycle(part, amount, {
        round: part === 'year'
      });
  }
  if ('hour' in value) switch (part) {
    case 'dayPeriod':
      {
        var hours = value.hour;
        var isPM = hours >= 12;
        return value.set({
          hour: isPM ? hours - 12 : hours + 12
        });
      }
    case 'hour':
    case 'minute':
    case 'second':
      return value.cycle(part, amount, {
        round: part !== 'hour',
        hourCycle: options.hour12 ? 12 : 24
      });
  }
  throw new Error('Unknown segment: ' + part);
}
function $596a1f0f523d6752$var$setSegment(value, part, segmentValue, options) {
  switch (part) {
    case 'day':
    case 'month':
    case 'year':
    case 'era':
      return value.set(_defineProperty({}, part, segmentValue));
  }
  if ('hour' in value && typeof segmentValue === 'number') switch (part) {
    case 'dayPeriod':
      {
        var hours = value.hour;
        var wasPM = hours >= 12;
        var isPM = segmentValue >= 12;
        if (isPM === wasPM) return value;
        return value.set({
          hour: wasPM ? hours - 12 : hours + 12
        });
      }
    case 'hour':
      // In 12 hour time, ensure that AM/PM does not change
      if (options.hour12) {
        var _hours = value.hour;
        var _wasPM = _hours >= 12;
        if (!_wasPM && segmentValue === 12) segmentValue = 0;
        if (_wasPM && segmentValue < 12) segmentValue += 12;
      }
    // fallthrough
    case 'minute':
    case 'second':
      return value.set(_defineProperty({}, part, segmentValue));
  }
  throw new Error('Unknown segment: ' + part);
}